import * as React from 'react';
import { PageWrapper } from '../uiComponents/layout/PageWrapper';
import { ContentWrapper } from '../uiComponents/layout/ContentWrapper';
import { SectionGroup } from '../uiComponents/layout/SectionGroup';
import { Section } from '../uiComponents/layout/Section';

export interface IkkeAdgangProps {
}

export function IkkeAdgang(props: IkkeAdgangProps) {
    return (
        <PageWrapper>
            <ContentWrapper>
                <SectionGroup header='Ikke adgang'>
                    <Section>
                        <div>
                            Du har ikke adgang til dette indhold.
                        </div>
                    </Section>
                </SectionGroup>
            </ContentWrapper>
        </PageWrapper>
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/IkkeAdgang.tsx